import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import animation_1 from '../assets/animations/app_logo.json';
import esti_text from '../assets/text/splash.svg';
import { useSystemTheme } from '../utils/useSystemTheme';

const IosSplash = ({ onFinish }) => {
    const [show, setShow] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);
    const theme = useSystemTheme();

    const isIOS = () => {
        if (typeof navigator !== 'undefined') {
            return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        }
        return false;
    };

    useEffect(() => {
        if (isIOS()) {
            setShow(true);
            const fadeTimer = setTimeout(() => setFadeOut(true), 3800);
            const hideTimer = setTimeout(() => {
                setShow(false);
                onFinish?.();
            }, 5000);

            return () => {
                clearTimeout(fadeTimer);
                clearTimeout(hideTimer);
            };
        } else {
            onFinish?.();
        }
    }, [onFinish]);

    const gradientClass =
        theme === 'dark'
            ? 'bg-gradient-to-tr from-[#FFF8F3] via-[#FFF8F3] to-[#FFF8F3]'
            : 'bg-gradient-to-tr from-[#FFF8F3] via-[#FFF8F3] to-[#FFF8F3]';

    if (!show) return null;

    return (
        <div
            className={`fixed inset-0 flex flex-col justify-center items-center z-[100] backdrop-blur-sm transition-opacity duration-400 ${gradientClass}`}
            style={{ opacity: fadeOut ? 0 : 1 }}
        >
            <Lottie animationData={animation_1} loop={false} className="w-56 h-56" />
            <img
                src={esti_text}
                className={`mt-4 text-white text-lg transition-opacity duration-700 ${fadeOut ? 'opacity-0' : 'opacity-100'}`}
                alt='Esti Text Logo'
            />
        </div>
    );
};

export default IosSplash;